import { Link as RouterLink, useParams } from 'react-router-dom'
import BaseTable, { BaseSearch }         from '../ui/components/base-table'
import {
  Autocomplete,
  Box,
  Button, Checkbox,
  Container, FormControl, FormControlLabel, FormGroup,
  Grid,
  InputLabel,
  Link, MenuItem, Paper, Select,
  Stack,
  TextField,
  Typography
}                                     from '@mui/material'
import Page                           from '../ui/components/Page'
import Iconify                        from '../ui/components/Iconify'
import { Trans, useTranslation }      from 'react-i18next'
import React, { useEffect, useState } from 'react'
import { useApi }                     from '../utils/api'
import { BaseBreadcrumbs }            from '../ui/components/BaseBreadcrumbs'
import ShortFormControl
                                      from '../ui/components/short-form-control'
import ShortFormSelect                from '../ui/components/short-form-select'
import Consts                         from '../Consts'
import { useSnackbar }                from 'notistack'
import { downloadBlob }               from '../utils/utils'

export default function DigitalAccessCodeGeneratePage() {

  const api = useApi()
  const { t } = useTranslation()
  const { serviceId } = useParams()
  const [service, setService] = useState()
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    api.service.detail(serviceId).then(srv => setService(srv)).catch(err => console.error(err))
  }, [serviceId])

  const onSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    try {
      const csvBlob = await api.digitalAccess.generate(serviceId, parseInt(formData.get('count')), formData.get('patternWeb'), formData.get('patternServer'))
      downloadBlob(csvBlob, 'codes.csv')
    } catch (e) {
      console.log(e)
      enqueueSnackbar(t('Can\'t generate digital access codes'), {
        variant: 'error'
      })
    }
  }

  return (<Page title={t('Digital access codes')}>
    <Container>
      <BaseBreadcrumbs key={'breadcrumb-services'}
                       title={t('Digital access codes')}
                       items={[]} />
      <Stack direction="row" alignItems="center" spacing={2} mb={2}>
        <Typography variant="h4" gutterBottom>{service?.title ?? ''}</Typography>
        <Box flexGrow={'1'} />
      </Stack>
      <Grid component={'form'} onSubmit={onSubmit} item xs={12}>
        <Paper sx={{ p: 2, width: '100%' }}>
          <Grid container sx={{ width: '100%' }} spacing={2}>
            <Grid item xs={12}>
              <ShortFormControl name={'count'} title={t('Count')} type={'number'} defaultValue={''} />
            </Grid>
            <Grid item xs={12}>
              <ShortFormControl name={'patternWeb'} title={t('Web codes pattern')} defaultValue={'SK-{w,2}{d,3}-{w,2}'} />
            </Grid>
            <Grid item xs={12}>
              <ShortFormControl name={'patternServer'} title={t('Server codes pattern')} defaultValue={'SK-{w,2}{d,3}-{w,2}'} />
            </Grid>
            <Grid item xs={12}>
              <p>
                Kódy sú generované automaticky podla zadanej predlohy. Každý znak sa zachováva v danom poradí, pričom je možné použiť nasledovné generované reťazce:
              </p>
              <Box px={2}>
                <ul>
                  <li><code>{"{d,2}"}</code> kde d je označenie pre číslo a 2 je dĺžka reťazca</li>
                  <li><code>{"{w,3}"}</code> kde w je označenie pre abecedu (A-Z) okrem (I a l) a 4 je dĺžka reťazca</li>
                  <li><code>{"{f,1}"}</code> kde f je označenie pre abecedu (A-Z a 0-9) okrem (I a l) a 1 je dĺžka reťazca</li>
                </ul>
              </Box>
            </Grid>
          </Grid>
        </Paper>
        <Stack direction={'row'} sx={{ mt: 2, px: 1 }}>
          <Button type={'submit'} variant={'contained'}>{t('Generate codes')}</Button>
        </Stack>
      </Grid>
    </Container>
  </Page>)

}